export default {
    menu_dashboard: 'Dashboard',
    menu_domain: 'Domain',
    menu_cloud_hosting: 'Cloud Hosting',
    menu_shared_hosting: 'Shared Hosting',
    menu_wp_hosting: 'WordPress Hosting',
    menu_cloud_server: 'Cloud Server',
    menu_invoice: 'Invoices',
    menu_profile: 'Profile',
    menu_wallet: 'Payments',
    menu_sms: 'SMS Service',
    menu_aws: 'AWS',
    menu_api: 'API Key Management',
    menu_promo_credit: 'Promo Credit',
    menu_affiliate: 'Affiliate',
    menu_loyalty_program: 'Loyalty',
    menu_ssl: 'SSL Certificates',
};
